export const translations = {
  nl: {
    nav: {
      process: 'Proces',
      faq: 'FAQ',
      contact: 'Contact'
    },
    hero: {
      title: 'Hoi ik ben een Creative Developer 👋',
      subtitle: 'Ik creëer innovatieve AR/XR ervaringen en mobile oplossingen die je merk tot leven brengen. Van Snapchat filters tot Meta Horizon experiences: ik help brands verbinding maken met hun publiek op nieuwe, creatieve manieren.',
      bulletPoints: [
        'AR/XR Experiences: Snapchat en TikTok filters, WebXR applicaties',
        'Mobile Innovation: Apps, Meta Horizon experiences, cross-platform solutions',
        'Creative Partnership: Van concept tot lancering, samen bouwen we iets bijzonders'
      ],
      cta: 'Laten we jouw visie tot leven brengen',
      quickResponse: 'Klaar om iets innovatiefs te creëren?'
    },
    impact: {
      title: 'Bewezen Impact',
      subtitle: 'Mijn AR filters en experiences hebben miljoenen mensen bereikt',
      stats: [
        {
          number: '785+',
          unit: 'miljoen',
          label: 'Totale weergaven',
          description: 'Snapchat en TikTok combined',
          icon: '📈'
        },
        {
          number: '780+',
          unit: 'miljoen',
          label: 'Snapchat weergaven',
          description: 'Viral AR filters en lenses',
          icon: '👻'
        },
        {
          number: '5.5+',
          unit: 'miljoen',
          label: 'TikTok weergaven',
          description: 'Interactive effecten',
          icon: '📱'
        }
      ]
    },
    usp: {
      title: 'Waarom kiezen merken voor creatieve technologie?',
      subtitle: 'In een wereld vol standaard oplossingen, help ik merken opvallen met innovatieve AR/XR en mobile ervaringen die écht impact maken.',
      items: [
        {
          title: 'Immersieve Ervaringen',
          description: 'AR filters en XR experiences die gebruikers boeien',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>'
        },
        {
          title: 'Mobile First',
          description: 'Apps en experiences geoptimaliseerd voor elke device',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" /></svg>'
        },
        {
          title: 'Creative Tech',
          description: 'Waar creativiteit en technologie elkaar ontmoeten',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" /></svg>'
        },
        {
          title: 'Platform Expertise',
          description: 'Snapchat, TikTok, Meta Horizon, WebXR en meer',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" /></svg>'
        },
        {
          title: 'Future Ready',
          description: 'Altijd aan de voorhoede van nieuwe technologieën',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" /></svg>'
        }
      ],
      examples: {
        title: 'Wat ik creëer:',
        subtitle: 'Van AR filters die viral gaan tot immersieve brand experiences - hier zijn enkele voorbeelden van wat mogelijk is:',
        items: [
          'AR Filters voor Snapchat en TikTok: Verhoog brand engagement met interactieve filters die gebruikers delen.',
          'Meta Horizon Experiences: Creëer virtuele spaces waar je community samenkomt en je merk beleeft.',
          'WebXR Applicaties: Browser-based AR/VR experiences die iedereen kan bezoeken, geen app download nodig.',
          'Interactive Mobile Apps: Van gamification tot utility apps die echt worden gebruikt.'
        ]
      },
      cta: 'Heb je een creatief project in gedachten? Laten we brainstormen.'
    },
    platforms: {
      title: 'Platforms & Technologieën',
      subtitle: 'Ik werk met de nieuwste tools en platforms om cutting-edge ervaringen te creëren',
      categories: [
        {
          title: 'AR/XR Platforms',
          items: [
            { name: 'Snapchat Lens Studio', icon: '👻', description: 'Custom AR filters en lenses' },
            { name: 'TikTok Effect House', icon: '📸', description: 'Interactive TikTok experiences' },
            { name: 'WebXR', icon: '🌐', description: 'Browser-based AR/VR experiences' },
            { name: 'Meta Horizon Worlds', icon: '🥽', description: 'Immersieve virtual spaces' }
          ]
        },
        {
          title: 'Mobile Development',
          items: [
            { name: 'React Native', icon: '📱', description: 'Cross-platform mobile apps' },
            { name: 'Expo', icon: '⚡', description: 'Rapid mobile development' },
            { name: 'Progressive Web Apps', icon: '💻', description: 'Web apps die voelen als native' },
            { name: 'iOS & Android', icon: '📲', description: 'Native platform optimization' }
          ]
        },
        {
          title: 'Creative Technologies',
          items: [
            { name: 'Three.js', icon: '🎨', description: '3D graphics en animaties' },
            { name: 'TypeScript', icon: '✨', description: 'Type-safe development' },
            { name: 'AI Integration', icon: '🤖', description: 'Smart features en automation' },
            { name: 'Real-time Systems', icon: '⚡', description: 'Live data en interactions' }
          ]
        }
      ]
    },
    process: {
      title: 'Van creatief concept naar immersieve ervaring',
      subtitle: 'Elk project is uniek, maar mijn creatieve proces zorgt ervoor dat jouw visie tot leven komt:',
      steps: [
        {
          step: '01',
          title: 'Creative Discovery',
          description: 'Samen verkennen we jouw merkvisie en welke ervaring je publiek wilt bieden'
        },
        {
          step: '02',
          title: 'Conceptualisatie',
          description: 'Van idee naar prototype: we maken het tastbaar en testen vroeg'
        },
        {
          step: '03',
          title: 'Development & Design',
          description: 'Ik bouw de ervaring met focus op gebruikersbeleving en technische kwaliteit'
        },
        {
          step: '04',
          title: 'Launch & Optimalisatie',
          description: 'Samen lanceren we en optimaliseren op basis van echte gebruikersdata'
        }
      ],
      cta: 'Klaar om je creatieve visie werkelijkheid te maken?'
    },
    caseStudy: {
      title: 'Creatieve projecten die impact maken',
      cases: [
        {
          title: 'AR Filter Campagne: Van concept naar viral moment',
          description: 'Voor een fashion brand creëerde ik een interactieve AR filter die gebruikers hun eigen stijl konden verkennen. Door gebruik te maken van advanced face tracking en 3D objecten, kregen gebruikers een gepersonaliseerde ervaring die ze graag deelden. De filter werd 50.000+ keer gebruikt in de eerste week.',
          results: [
            'Meer dan 50.000 filter uses in week 1',
            '300% toename in social media engagement',
            'Organische verspreiding naar 8 verschillende landen',
            'Direct meetbare impact op brand awareness'
          ]
        },
        {
          title: 'Meta Horizon Experience: Virtual brand space',
          description: 'Een innovatieve virtual experience waarin bezoekers een immersieve merkwereld konden ontdekken. Complete met interactieve elementen, branded environments en social features die de community samenbrachten in een unieke digitale space.',
          results: [
            'Gemiddeld 15 minuten session tijd per bezoeker',
            'Hoge return rate: 40% kwam terug voor meer',
            'Unieke brand positioning in de metaverse',
            'Positive feedback op innovation en user experience'
          ]
        }
      ],
      cta: 'Wil je ook zo\'n impactvolle ervaring? Laten we brainstormen.'
    },
    faq: {
      title: 'Veelgestelde Vragen',
      questions: [
        {
          question: 'Wat voor soort projecten maak je?',
          answer: 'Ik focus op AR/XR ervaringen (Snapchat/TikTok filters, WebXR), mobile apps, Meta Horizon experiences, en creatieve web applicaties. Alles wat merken helpt om op een innovatieve manier met hun publiek te verbinden.'
        },
        {
          question: 'Hoe lang duurt een project?',
          answer: 'Dit hangt af van de complexiteit. Een AR filter kan binnen 2-3 weken klaar zijn, terwijl een complete Meta Horizon experience 6-8 weken kan duren. We bespreken altijd realistische timelines tijdens ons eerste gesprek.'
        },
        {
          question: 'Werk je alleen of met een team?',
          answer: 'Ik werk als creatieve partner - soms solo voor kleinere projecten, soms met gespecialiseerde freelancers voor grotere projecten. Je hebt altijd direct contact met mij als creative lead.'
        },
        {
          question: 'Hoe zorg je ervoor dat het project bij mijn merk past?',
          answer: 'Elk project begint met een diepe dive in je merkidentiteit en doelgroep. Ik geloof in nauwe samenwerking: jij bent de expert van je merk, ik ben de expert in creatieve technologie.'
        },
        {
          question: 'Kan je ook onderhoud en updates doen?',
          answer: 'Absoluut! Veel van mijn projecten hebben een ongoing relationship. Of het nu gaat om nieuwe features, platform updates, of seizoensgebonden aanpassingen: ik denk graag mee op lange termijn.'
        }
      ]
    },
    contact: {
      title: 'Laten we iets bijzonders creëren',
      subtitle: 'Heb je een creatief project in gedachten? Of wil je gewoon brainstormen over de mogelijkheden? Ik hoor graag van je: van eerste idee tot volledige campagne.',
      form: {
        name: 'Naam',
        email: 'E-mail',
        projectDescription: 'Wat wil je creëren?',
        projectPlaceholder: 'Vertel over je merk, je doelgroep, en wat voor ervaring je voor ogen hebt...',
        sendMessage: 'Laten we connecten',
        sendEmail: 'Stuur ons een e-mail',
        directEmail: 'Of mail direct naar: info@joshua-digital.com',
        sending: 'Bericht versturen...',
        responseTime: 'Ik reageer meestal binnen 24 uur'
      }
    },
    footer: {
      rights: 'Alle rechten voorbehouden'
    }
  },
  en: {
    nav: {
      process: 'Process',
      faq: 'FAQ',
      contact: 'Contact'
    },
    hero: {
      title: 'Hi I\'m a Creative Developer 👋',
      subtitle: 'I create innovative AR/XR experiences and mobile solutions that bring your brand to life. From Snapchat filters to Meta Horizon experiences: I help brands connect with their audience in new, creative ways.',
      bulletPoints: [
        'AR/XR Experiences: Snapchat and TikTok filters, WebXR applications',
        'Mobile Innovation: Apps, Meta Horizon experiences, cross-platform solutions',
        'Creative Partnership: From concept to launch, we build something special together'
      ],
      cta: 'Let\'s bring your vision to life',
      quickResponse: 'Ready to create something innovative?'
    },
    impact: {
      title: 'Proven Impact',
      subtitle: 'My AR filters and experiences have reached millions of people',
      stats: [
        {
          number: '785+',
          unit: 'million',
          label: 'Total views',
          description: 'Snapchat and TikTok combined',
          icon: '📈'
        },
        {
          number: '780+',
          unit: 'million',
          label: 'Snapchat views',
          description: 'Viral AR filters and lenses',
          icon: '👻'
        },
        {
          number: '5.5+',
          unit: 'million',
          label: 'TikTok views',
          description: 'Interactive effects',
          icon: '📱'
        }
      ]
    },
    usp: {
      title: 'Why brands choose creative technology?',
      subtitle: 'In a world full of standard solutions, I help brands stand out with innovative AR/XR and mobile experiences that truly make an impact.',
      items: [
        {
          title: 'Immersive Experiences',
          description: 'AR filters and XR experiences that captivate users',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>'
        },
        {
          title: 'Mobile First',
          description: 'Apps and experiences optimized for every device',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" /></svg>'
        },
        {
          title: 'Creative Tech',
          description: 'Where creativity meets technology',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" /></svg>'
        },
        {
          title: 'Platform Expertise',
          description: 'Snapchat, TikTok, Meta Horizon, WebXR and more',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" /></svg>'
        },
        {
          title: 'Future Ready',
          description: 'Always at the forefront of new technologies',
          icon: '<svg className="w-10 h-10 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" /></svg>'
        }
      ],
      examples: {
        title: 'What I create:',
        subtitle: 'From viral AR filters to immersive brand experiences - here are some examples of what\'s possible:',
        items: [
          'AR Filters for Snapchat and TikTok: Boost brand engagement with interactive filters users love to share.',
          'Meta Horizon Experiences: Create virtual spaces where your community comes together and experiences your brand.',
          'WebXR Applications: Browser-based AR/VR experiences anyone can visit, no app download required.',
          'Interactive Mobile Apps: From gamification to utility apps that actually get used.'
        ]
      },
      cta: 'Got a creative project in mind? Let\'s brainstorm.'
    },
    platforms: {
      title: 'Platforms & Technologies',
      subtitle: 'I work with the latest tools and platforms to create cutting-edge experiences',
      categories: [
        {
          title: 'AR/XR Platforms',
          items: [
            { name: 'Snapchat Lens Studio', icon: '👻', description: 'Custom AR filters and lenses' },
            { name: 'TikTok Effect House', icon: '📸', description: 'Interactive TikTok experiences' },
            { name: 'WebXR', icon: '🌐', description: 'Browser-based AR/VR experiences' },
            { name: 'Meta Horizon Worlds', icon: '🥽', description: 'Immersive virtual spaces' }
          ]
        },
        {
          title: 'Mobile Development',
          items: [
            { name: 'React Native', icon: '📱', description: 'Cross-platform mobile apps' },
            { name: 'Expo', icon: '⚡', description: 'Rapid mobile development' },
            { name: 'Progressive Web Apps', icon: '💻', description: 'Web apps that feel native' },
            { name: 'iOS & Android', icon: '📲', description: 'Native platform optimization' }
          ]
        },
        {
          title: 'Creative Technologies',
          items: [
            { name: 'Three.js', icon: '🎨', description: '3D graphics and animations' },
            { name: 'TypeScript', icon: '✨', description: 'Type-safe development' },
            { name: 'AI Integration', icon: '🤖', description: 'Smart features and automation' },
            { name: 'Real-time Systems', icon: '⚡', description: 'Live data and interactions' }
          ]
        }
      ]
    },
    process: {
      title: 'From creative concept to immersive experience',
      subtitle: 'Every project is unique, but my creative process ensures your vision comes to life:',
      steps: [
        {
          step: '01',
          title: 'Creative Discovery',
          description: 'Together we explore your brand vision and what experience you want to offer your audience'
        },
        {
          step: '02',
          title: 'Conceptualization',
          description: 'From idea to prototype: we make it tangible and test early'
        },
        {
          step: '03',
          title: 'Development & Design',
          description: 'I build the experience with focus on user experience and technical quality'
        },
        {
          step: '04',
          title: 'Launch & Optimization',
          description: 'Together we launch and optimize based on real user data'
        }
      ],
      cta: 'Ready to make your creative vision reality?'
    },
    caseStudy: {
      title: 'Creative projects that make impact',
      cases: [
        {
          title: 'AR Filter Campaign: From concept to viral moment',
          description: 'For a fashion brand, I created an interactive AR filter that let users explore their own style. Using advanced face tracking and 3D objects, users got a personalized experience they loved to share. The filter was used 50,000+ times in the first week.',
          results: [
            'More than 50,000 filter uses in week 1',
            '300% increase in social media engagement',
            'Organic spread to 8 different countries',
            'Direct measurable impact on brand awareness'
          ]
        },
        {
          title: 'Meta Horizon Experience: Virtual brand space',
          description: 'An innovative virtual experience where visitors could discover an immersive brand world. Complete with interactive elements, branded environments and social features that brought the community together in a unique digital space.',
          results: [
            'Average 15 minutes session time per visitor',
            'High return rate: 40% came back for more',
            'Unique brand positioning in the metaverse',
            'Positive feedback on innovation and user experience'
          ]
        }
      ],
      cta: 'Want such an impactful experience too? Let\'s brainstorm.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      questions: [
        {
          question: 'What kind of projects do you create?',
          answer: 'I focus on AR/XR experiences (Snapchat/TikTok filters, WebXR), mobile apps, Meta Horizon experiences, and creative web applications. Everything that helps brands connect with their audience in innovative ways.'
        },
        {
          question: 'How long does a project take?',
          answer: 'This depends on complexity. An AR filter can be ready in 2-3 weeks, while a complete Meta Horizon experience might take 6-8 weeks. We always discuss realistic timelines during our first conversation.'
        },
        {
          question: 'Do you work alone or with a team?',
          answer: 'I work as a creative partner: sometimes solo for smaller projects, sometimes with specialized freelancers for larger projects. You always have direct contact with me as creative lead.'
        },
        {
          question: 'How do you ensure the project fits my brand?',
          answer: 'Every project starts with a deep dive into your brand identity and target audience. I believe in close collaboration: you\'re the expert of your brand, I\'m the expert in creative technology.'
        },
        {
          question: 'Can you also do maintenance and updates?',
          answer: 'Absolutely! Many of my projects have an ongoing relationship. Whether it\'s new features, platform updates, or seasonal adjustments: I love thinking along long-term.'
        }
      ]
    },
    contact: {
      title: 'Let\'s create something special',
      subtitle: 'Got a creative project in mind? Or just want to brainstorm about possibilities? I\'d love to hear from you: from first idea to full campaign.',
      form: {
        name: 'Name',
        email: 'Email',
        projectDescription: 'What do you want to create?',
        projectPlaceholder: 'Tell me about your brand, your audience, and what kind of experience you envision...',
        sendMessage: 'Let\'s connect',
        sendEmail: 'Send me an email',
        directEmail: 'Or mail directly to: info@joshua-digital.com',
        sending: 'Sending message...',
        responseTime: 'I usually respond within 24 hours'
      }
    },
    footer: {
      rights: 'All rights reserved'
    }
  }
}; 